import React, { useState, useEffect } from "react";
import { Icon } from '@iconify/react/dist/iconify.js';
import axios from 'axios'; 
import { toast, ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 

const ComplainFormPageUpdate = ({ complainId }) => {
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const authUserId = storedUser._id;

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [formData, setFormData] = useState({
    dept_id: "",
    district_id: "",
    complaint_nature_id: "",
    complaint_nearby_place: "",
    complaint_detail: "",
    complainant_name: "",
    complainant_address: "",
    complainant_phone: "",
    complainant_email: "",
    complaint_time: "",
    complaint_additional_remarks: "",
    complainant_phone_secondry: "",
    other_nature: "",
    received_by: authUserId,
    status: "Open",
    priority_level: "",
    cnic: "",
    complaint_source: "",
    // Complainant location fields
    complainant_city: "",
    complainant_tehsil: "",
    complainant_district: "",
    // Complaint location fields
    complaint_city: "",
    complaint_tehsil: "",
    complaint_district: "",
    complaint_address: ""
  });

  const [departments, setDepartments] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [tehsils, setTehsils] = useState([]);
  const [complaintNatures, setComplaintNatures] = useState([]);
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Complaint source options
  const complaintSources = [
    { value: "Helpline", label: "Helpline" },
    { value: "Chatbot", label: "Chatbot" },
    { value: "Whatsapp", label: "Whatsapp" },
    { value: "Social Media", label: "Social Media" },
    { value: "By Post", label: "By Post" },
    { value: "By Hand", label: "By Hand" },
    { value: "By Email", label: "By Email" },
    { value: "Other", label: "Other" }
  ];

  const complaintReferredBy = [
    { value: "Chief Minister's Secretariat", label: "Chief Minister's Secretariat" },
    { value: "Chief Secretariat Office", label: "Chief Secretariat Office" },
    { value: "Administrative Dept (Secretariat)", label: "Administrative Dept (Secretariat)" },
    { value: "Attached Department", label: "Attached Department" },
    { value: "Control Room (Helpline)", label: "Control Room (Helpline)" },
    { value: "Chief Conservator of Forests (PM&E)", label: "Chief Conservator of Forests (PM&E)" },
    { value: "Chief Conservator of Forests (Central)", label: "Chief Conservator of Forests (Central)" },
    { value: "Chief Conservator of Forests (Northern)", label: "Chief Conservator of Forests (Northern)" },
    { value: "Chief Conservator of Forests (Southern)", label: "Chief Conservator of Forests (Southern)" },
    { value: "Other", label: "Other" }
  ];

  // Priority level options
  const priorityLevels = [
    { value: "Critical", label: "Critical" },
    { value: "High", label: "High" },
    { value: "Medium", label: "Medium" },
    { value: "Low", label: "Low" }
  ];

  // Fetch complaint data to update
  useEffect(() => {
    const fetchComplaintData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/complaints/${complainId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.status) {
          const complaintData = response.data.data;
          setFormData({
            dept_id: complaintData.dept_id?._id || "",
            district_id: complaintData.district_id?._id || "",
            complaint_nature_id: complaintData.complaint_nature_id?._id || "",
            complaint_nearby_place: complaintData.near_by_place || "",
            complaint_detail: complaintData.complaint_detail || "",
            complainant_name: complaintData.complainant_name || "",
            complainant_address: complaintData.complainant_address || "",
            complainant_phone: complaintData.complainant_contact_no || "",
            complainant_email: complaintData.complainant_email || "",
            complaint_time: formatDateForInput(complaintData.time_of_call) || "",
            complaint_additional_remarks: complaintData.remarks || "",
            complainant_phone_secondry: complaintData.complainant_contact_no_sec || "",
            other_nature: complaintData.other_nature || "",
            received_by: complaintData.received_by || authUserId,
            status: complaintData.status || "Open",
            priority_level: complaintData.priority_level || "",
            cnic: complaintData.complainant_cnic || "",
            complaint_source: complaintData.complaint_source || "",
            complaint_reffered_by: complaintData.complaint_reffered_by || "",
            // Location fields
            complainant_city: complaintData.complainant_city_id?._id || "",
            complainant_tehsil: complaintData.complainant_tehsil_id?._id || "",
            complainant_district: complaintData.complainant_district_id?._id || "",
            complaint_city: complaintData.complaint_city_id?._id || "",
            complaint_tehsil: complaintData.complaint_tehsil_id?._id || "",
            complaint_district: complaintData.complaint_district_id?._id || "",
            complaint_address: complaintData.complaint_address || ""
          });

          // Check if "Other" nature is selected
          if (complaintData.complaint_nature_id?.name?.toLowerCase() === "other") {
            setShowOtherInput(true);
          }
        }
      } catch (error) {
        toast.error("Failed to fetch complaint data.");
        console.error("Error fetching complaint data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchComplaintData();
  }, [API_BASE_URL, complainId, authUserId]);

  // Fetch Departments
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/departments/get-all-departments`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setDepartments(response.data.data);
      } catch (error) {
        toast.error("Failed to fetch departments.");
        console.error("Error fetching departments:", error);
      }
    };
    fetchDepartments();
  }, [API_BASE_URL]);

  // Fetch Districts
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/districts/get-all-districts`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setDistricts(response.data.data);
      } catch (error) {
        toast.error("Failed to fetch districts.");
        console.error("Error fetching districts:", error);
      }
    };
    fetchDistricts();
  }, [API_BASE_URL]);

  // Fetch Cities
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/generic/city`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCities(response.data.data);
      } catch (error) {
        toast.error("Failed to fetch cities.");
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, [API_BASE_URL]);

  // Fetch Tehsils
  useEffect(() => {
    const fetchTehsils = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/generic/tehsil`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setTehsils(response.data.data);
      } catch (error) {
        toast.error("Failed to fetch tehsils.");
        console.error("Error fetching tehsils:", error);
      }
    };
    fetchTehsils();
  }, [API_BASE_URL]);

  // Fetch Complaint Natures
  useEffect(() => {
    const fetchComplaintNatures = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/complaint-natures/get-all-complaint-natures`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setComplaintNatures(response.data.data);
      } catch (error) {
        toast.error("Failed to fetch complaint natures.");
        console.error("Error fetching complaint natures:", error);
      }
    };
    fetchComplaintNatures();
  }, [API_BASE_URL]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "cnic") {
      let formattedValue = value.replace(/\D/g, ''); 
      
      if (formattedValue.length > 5) {
        formattedValue = formattedValue.substring(0, 5) + '-' + formattedValue.substring(5);
      }
      if (formattedValue.length > 13) {
        formattedValue = formattedValue.substring(0, 13) + '-' + formattedValue.substring(13);
      }
      
      formattedValue = formattedValue.substring(0, 15);
      
      setFormData({
        ...formData,
        [name]: formattedValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const cnicRegex = /^[0-9]{5}-[0-9]{7}-[0-9]{1}$/;

    if (name === "cnic" && value && !cnicRegex.test(value)) {
      toast.error("Please enter a valid CNIC in the format 12345-6789012-3");
    }
    const pakPhoneRegex = /^(\+92|0)3[0-9]{9}$/;

    if ((name === "complainant_phone" || name === "complainant_phone_secondry") && value && !pakPhoneRegex.test(value)) {
      toast.error("Please enter a valid Pakistani phone number (e.g., +923001234567 or 03001234567)");
    }
  };

  const handleSelectChange = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });

    // Show other nature input field when "Other" is selected
    if (name === "complaint_nature_id") {
      const selectedNature = complaintNatures.find(nature => nature._id === value);
      if (selectedNature && selectedNature.name.toLowerCase() === "other") {
        setShowOtherInput(true);
      } else {
        setShowOtherInput(false);
        setFormData(prev => ({ ...prev, other_nature: "" }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "dept_id",
      "complainant_district",
      "complaint_nature_id",
      "complaint_nearby_place",
      "complaint_detail",
      "complainant_name",
      "complainant_address",
      "complainant_phone",
      "received_by",
      "status",
      "priority_level",
      "cnic",
      "complaint_source"
    ];

    const isFormValid = requiredFields.every((field) => formData[field] !== "");

    if (!isFormValid) {
      toast.error("Please fill in all required details!");
      return;
    }

    const pakPhoneRegex = /^(\+92|0)3[0-9]{9}$/;
    if (!pakPhoneRegex.test(formData.complainant_phone)) {
      toast.error("Please enter a valid Primary phone number (e.g., +923001234567 or 03001234567)");
      return;
    }

    if (formData.complainant_phone_secondry && !pakPhoneRegex.test(formData.complainant_phone_secondry)) {
      toast.error("Please enter a valid Secondary phone number (e.g., +923001234567 or 03001234567)");
      return;
    }

    if (formData.complainant_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.complainant_email)) {
      toast.error("Invalid email format!");
      return;
    }

    // Prepare data for API
    const apiData = {
      complainant_name: formData.complainant_name,
      complainant_address: formData.complainant_address,
      complainant_contact_no: formData.complainant_phone,
      complainant_contact_no_sec: formData.complainant_phone_secondry,
      time_of_call: formData.complaint_time || new Date().toISOString(),
      complaint_detail: formData.complaint_detail,
      dept_id: formData.dept_id,
      complaint_nature_id: formData.complaint_nature_id,
      near_by_place: formData.complaint_nearby_place,
      remarks: formData.complaint_additional_remarks,
      received_by: authUserId,
      status: formData.status,
      priority_level: formData.priority_level,
      complainant_cnic: formData.cnic,
      complaint_source: formData.complaint_source,
      // Include other nature if specified
      ...(showOtherInput && { other_nature: formData.other_nature }),
      // Location fields
      complainant_city_id: formData.complainant_city,
      complainant_tehsil_id: formData.complainant_tehsil,
      complainant_district_id: formData.complainant_district,
      complaint_city_id: formData.complaint_city,
      complaint_tehsil_id: formData.complaint_tehsil,
      complaint_district_id: formData.complaint_district,
      complaint_address: formData.complaint_address
    };

    try {
      const token = localStorage.getItem("token");
      const response = await axios.patch(`${API_BASE_URL}/backend/complaints/${complainId}`, apiData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.data.status) {
        toast.success("Complaint Updated Successfully!");
      }
    } catch (error) {
      toast.error("Failed to update complaint. Please try again.");
      console.error("Error updating complaint:", error);
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="col-lg-12 col-md-12 col-sm-12">
      <ToastContainer /> 
      <form onSubmit={handleSubmit}>
        <div className="">
          <div className="text-center ">
            <h6 className="mb-20 text-2xl font-bold text-gray-800 flex items-center">
              <Icon icon="mdi:file-document-alert" className="text-3xl  mx-3 my-1 " />
              Update Complaint Form
            </h6>
          </div>
          
          <div className="">
            <div> Complainant Information</div>
            <hr className="pb-10"/>
            <div className="row gy-3">
              {/* Department */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:office-building" className="text-lg" />
                  Department
                </label>
                <select
                  className="form-select"
                  name="dept_id"
                  value={formData.dept_id}
                  onChange={handleSelectChange}
                  required
                >
                  <option value="">Select Department</option>
                  {departments.map((dept) => (
                    <option key={dept._id} value={dept._id}>
                      {dept.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Complainant Name */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:account" className="text-lg" />
                  Complainant Name
                </label>
                <input
                  type="text"
                  name="complainant_name"
                  placeholder="Complainant Name"
                  className="form-control"
                  value={formData.complainant_name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Complainant Phone */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:phone" className="text-lg" />
                  Complainant Phone
                </label>
                <input
                  type="text"
                  name="complainant_phone"
                  placeholder="Phone Number (e.g., +923001234567 or 03001234567)"
                  className="form-control"
                  value={formData.complainant_phone}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  pattern="(\+92|0)3[0-9]{9}"
                  maxLength="13"
                  title="Please enter a valid Pakistani phone number (e.g., +923001234567 or 03001234567)"
                  required
                />
              </div>

              {/* Complainant Phone Secondary */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:phone" className="text-lg" />
                  Complainant Phone Secondary 
                </label>
                <input
                  type="text"
                  name="complainant_phone_secondry"
                  placeholder="Phone Number Secondary (e.g., +923001234567 or 03001234567)"
                  className="form-control"
                  value={formData.complainant_phone_secondry}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  pattern="(\+92|0)3[0-9]{9}"
                  maxLength="13"
                  title="Please enter a valid Pakistani phone number (e.g., +923001234567 or 03001234567)"
                />
              </div>

              {/* Complainant CNIC */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:card-account-details" className="text-lg" />
                  Complainant CNIC
                </label>
                <input
                  type="text"
                  name="cnic"
                  placeholder="CNIC (e.g., 12345-6789012-3)"
                  className="form-control"
                  value={formData.cnic}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  pattern="[0-9]{5}-[0-9]{7}-[0-9]{1}"
                  maxLength="15"
                  title="Please enter a valid CNIC in the format 12345-6789012-3"
                  required
                />
              </div>

              {/* Complainant Email */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:email" className="text-lg" />
                  Complainant Email
                </label>
                <input
                  type="text"
                  name="complainant_email"
                  placeholder="info@gmail.com"
                  className="form-control"
                  value={formData.complainant_email}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                />
              </div>

              {/* Complainant Address */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:home" className="text-lg" />
                  Complainant Address
                </label>
                <input
                  type="text"
                  name="complainant_address"
                  placeholder="Complainant Address"
                  className="form-control"
                  value={formData.complainant_address}
                  onChange={handleInputChange}
                  required
                />
              </div>

            

              {/* Complainant City */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:city" className="text-lg" />
                  Complainant City 
                </label>
                <select
                  className="form-select"
                  name="complainant_city"
                  value={formData.complainant_city}
                  onChange={handleSelectChange}
                >
                  <option value="">Select City</option>
                  {cities.map((city) => (
                    <option key={city._id} value={city._id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Complainant Tehsil */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:map-marker" className="text-lg" />
                  Complainant Tehsil
                </label>
                <select
                  className="form-select"
                  name="complainant_tehsil"
                  value={formData.complainant_tehsil}
                  onChange={handleSelectChange}
                >
                  <option value="">Select Tehsil</option>
                  {tehsils.map((tehsil) => (
                    <option key={tehsil._id} value={tehsil._id}>
                      {tehsil.name}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Complainant District */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:map-marker" className="text-lg" />
                  Complainant District
                </label>
                <select
                  className="form-select"
                  name="complainant_district"
                  value={formData.complainant_district}
                  onChange={handleSelectChange}
                  required
                >
                  <option value="">Select District</option>
                  {districts.map((district) => (
                    <option key={district._id} value={district._id}>
                      {district.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            
            <div className="row my-3 mx-1">
              <div>Complaint Information</div>
              <hr/>
            </div>
            
            <div className="row gy-3">
              {/* Complaint Source */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:source" className="text-lg" />
                  Complaint Source
                </label>
                <select
                  className="form-select"
                  name="complaint_source"
                  value={formData.complaint_source}
                  onChange={handleSelectChange}
                  required
                >
                  <option value="">Select Source</option>
                  {complaintSources.map((source) => (
                    <option key={source.value} value={source.value}>
                      {source.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Complaint Reffered By */}
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <label className="form-label d-flex align-items-center gap-2">
                    <Icon icon="mdi:source" className="text-lg" />
                    Complaint Reffered By
                  </label>
                  <select
                    className="form-select"
                    name="complaint_reffered_by"
                    value={formData.complaint_reffered_by}
                    onChange={handleSelectChange}
                    required
                  >
                    <option value="">Select Reffered By</option>
                    {complaintReferredBy.map((source) => (
                      <option key={source.value} value={source.value}>
                        {source.label}
                      </option>
                    ))}
                  </select>
                </div>
              
              {/* Nature of Complaint */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:alert-circle-outline" className="text-lg" />
                  Nature of Complaint
                </label>
                <select
                  className="form-select"
                  name="complaint_nature_id"
                  value={formData.complaint_nature_id}
                  onChange={handleSelectChange}
                  required
                >
                  <option value="">Select a complaint type</option>
                  {complaintNatures.map((nature) => (
                    <option key={nature._id} value={nature._id}>
                      {nature.name}
                    </option>
                  ))}
                </select>
                
                {/* Other nature input (shown when "Other" is selected) */}
                {showOtherInput && (
                  <div className="mt-3">
                    <label className="form-label d-flex align-items-center gap-2">
                      <Icon icon="mdi:pencil-outline" className="text-lg" />
                      Specify Other Nature
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="other_nature"
                      value={formData.other_nature}
                      onChange={handleInputChange}
                      placeholder="Please specify the nature of the complaint"
                    />
                  </div>
                )}
              </div>

              {/* Priority Level */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:priority-high" className="text-lg" />
                  Priority Level
                </label>
                <select
                  className="form-select"
                  name="priority_level"
                  value={formData.priority_level}
                  onChange={handleSelectChange}
                  required
                >
                  <option value="">Select Priority</option>
                  {priorityLevels.map((level) => (
                    <option key={level.value} value={level.value}>
                      {level.label}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Complaint Address */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:home" className="text-lg" />
                  Complaint Address
                </label>
                <input
                  type="text"
                  name="complaint_address"
                  placeholder="Complaint Address"
                  className="form-control"
                  value={formData.complaint_address}
                  onChange={handleInputChange}
                />
              </div>
                {/* Nearby Landmark */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:map-marker-radius" className="text-lg" />
                  Nearby Landmark of Complainant
                </label>
                <input
                  type="text"
                  name="complaint_nearby_place"
                  placeholder="Nearby Landmark of Complainant"
                  className="form-control"
                  value={formData.complaint_nearby_place}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              {/* Complaint City */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:city" className="text-lg" />
                  Complaint City 
                </label>
                <select
                  className="form-select"
                  name="complaint_city"
                  value={formData.complaint_city}
                  onChange={handleSelectChange}
                >
                  <option value="">Select City</option>
                  {cities.map((city) => (
                    <option key={city._id} value={city._id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Complaint Tehsil */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:map-marker" className="text-lg" />
                  Complaint Tehsil
                </label>
                <select
                  className="form-select"
                  name="complaint_tehsil"
                  value={formData.complaint_tehsil}
                  onChange={handleSelectChange}
                >
                  <option value="">Select Tehsil</option>
                  {tehsils.map((tehsil) => (
                    <option key={tehsil._id} value={tehsil._id}>
                      {tehsil.name}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Complaint District */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:map-marker" className="text-lg" />
                  Complaint District
                </label>
                <select
                  className="form-select"
                  name="complaint_district"
                  value={formData.complaint_district}
                  onChange={handleSelectChange}
                >
                  <option value="">Select District</option>
                  {districts.map((district) => (
                    <option key={district._id} value={district._id}>
                      {district.name}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Complaint Time */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:clock" className="text-lg" />
                  Complaint Date & Time
                </label>
                <input
                  type="datetime-local"
                  name="complaint_time"
                  className="form-control"
                  value={formData.complaint_time}
                  onChange={handleInputChange}
                />
              </div>

             

              {/* Complaint Detail */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:file-document" className="text-lg" />
                  Complaint Detail
                </label>
                <textarea
                  name="complaint_detail"
                  className="form-control"
                  rows={4}
                  placeholder="Enter a description..."
                  value={formData.complaint_detail}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Additional Remarks */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:note-text" className="text-lg" />
                  Additional Remarks
                </label>
                <textarea
                  name="complaint_additional_remarks"
                  className="form-control"
                  rows={4}
                  placeholder="Additional Remarks..."
                  value={formData.complaint_additional_remarks}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
          
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-success text-sm btn-sm px-6 py-12 radius-12 my-24 mx-10 col-lg-2 col-md-4 col-sm-12"
              type="submit"
            >
              Update Complaint
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ComplainFormPageUpdate;